module.exports = __webpack_public_path__ + "img/dm.e9955d3a.svg";